export function AgesContainer(props) {
  return (
    <div className="rounded overflow-hidden border border-borderGray grid grid-cols-7">
      {props.children}
    </div>
  );
}
